/* globals APIURL */

const BASE_URL = APIURL || window.location.origin + window.location.pathname;
const CLIENT_ID = '709a3414-c9a6-4e6f-9311-7e95d92aa8e5';
const TENANT_URL = 'jsDRM.onmicrosoft.com';

apiInterceptor.$inject = ['$q', 'Alerts', '$location'];

function apiInterceptor($q, Alerts, $location) {
    function request(config) {
        if (config.url.substring(0, 3) === 'api') {
            config.url = BASE_URL + config.url;
        }
        return config;
    }

    function responseError(rejection) {
        let showError = true;
        if (rejection.status === 404) {
            console.log('Response Error 404', rejection);
            $location.path('/notfound');
            showError = false;
        }

        if (rejection.status === 401) {
            console.log('Response Error 401', rejection);
            $location.path('/accessdenied');
            showError = false;
        }

        if (showError) Alerts.error(rejection);
        return $q.reject(rejection);
    }

    return {
        request,
        responseError
    };
}

Interceptors.$inject = ['$httpProvider', 'adalAuthenticationServiceProvider'];

function Interceptors($httpProvider, adalAuthenticationServiceProvider) {
    $httpProvider.interceptors.push(apiInterceptor);

    var endpoints = {};
    endpoints[BASE_URL] = CLIENT_ID;

    adalAuthenticationServiceProvider.init({
            instance: 'https://login.microsoftonline.com/',
            tenant: TENANT_URL,
            clientId: CLIENT_ID,
            cacheLocation: 'localStorage',
            endpoints: endpoints,
            disableRenewal: true,   //careful!  logic controlling this option is wrong in adal.js.  true actually means false.
            preserveCacheOnError: true
        },
        $httpProvider
    );
}

export default Interceptors;



// WEBPACK FOOTER //
// ./src/js/core/core.interceptors.js